"use strict";
// @ts-nocheck
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const plugin_config_1 = __importDefault(require("@app/const/plugin-config"));
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const calendar_settings_modal_1 = require("@app/component/modals/calendar-settings/calendar-settings-modal");
const shift_1 = require("@app/component/modals/shift-1.5/shift");
const unavailability_modal_1 = require("@app/component/modals/unavailability-1.5/unavailability-modal");
const util_1 = require("@app/util");
const use_workspace_unavailability_categories_1 = require("@app/util/hooks/use-workspace-unavailability-categories");
const i18n_1 = require("@app/util/i18n");
const use_modal_hoc_1 = require("@app/util/modal/use-modal-hoc");
const _ui_1 = require("@ui");
const components_1 = require("./components");
const connect_1 = __importDefault(require("./connect"));
require("./index.scss");
class Controls extends react_1.default.Component {
    searchTimer = null;
    constructor(props) {
        super(props);
        this.state = {
            searchActive: false,
            searchQuery: '',
            filtersActive: false,
        };
        this.applySearch = this._applySearch.bind(this);
        this.handleKeypress = this._handleKeypress.bind(this);
        this.setCalendarWarnings = this._setCalendarWarnings.bind(this);
        this.searchTimer = setTimeout(function () { }, 0);
    }
    shouldComponentUpdate(nextProps, nextState) {
        if (util_1.miscUtil.safeStringify(this.props.isLoadingRelevantData) !==
            util_1.miscUtil.safeStringify(nextProps.isLoadingRelevantData)) {
            return true;
        }
        if (this.props.userId !== nextProps.userId) {
            return true;
        }
        if (this.props.warningCounts !== nextProps.warningCounts ||
            this.props.calendar.displayStatistics !==
                nextProps.calendar.displayStatistics ||
            this.props.calendar.displayCapacities !==
                nextProps.calendar.displayCapacities ||
            this.props.calendar.displayRowTemplates !==
                nextProps.calendar.displayRowTemplates ||
            this.props.calendar.displayRowUnassigned !==
                nextProps.calendar.displayRowUnassigned ||
            this.props.calendar.displayRowOffers !== nextProps.calendar.displayRowOffers) {
            return true;
        }
        if (this.props.warningCounts !== nextProps.warningCounts) {
            return true;
        }
        if (util_1.miscUtil.safeStringify(this.props.calendarFilters) !==
            util_1.miscUtil.safeStringify(nextProps.calendarFilters)) {
            return true;
        }
        if (this.props.employees !== nextProps.employees) {
            return true;
        }
        if (this.props.positions !== nextProps.positions) {
            return true;
        }
        if (this.state.searchActive !== nextState.searchActive ||
            this.state.searchQuery !== nextState.searchQuery ||
            this.state.filtersActive !== nextState.filtersActive) {
            return true;
        }
        return false;
    }
    _applySearch(query) {
        const { shifts, employees, positions, calendar, setCalendarSearch } = this.props;
        if (query === '') {
            setCalendarSearch({ query, results: [] });
            return;
        }
        query = query
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase();
        // un-highlight all the events
        const allHl = [...document.querySelectorAll('.ds-c-event.is-highlighted')];
        allHl.map((el) => {
            el.classList.remove('is-highlighted');
        });
        if (query.length < 2) {
            return false;
        }
        else {
            if (!calendar || !calendar.date)
                return;
            // get relevant items (shifs, unavs and employees in calendar's period)
            let relevantItems = (shifts || []).map((s) => {
                if (s.period &&
                    (0, moment_1.default)(s.period.start).isSameOrAfter(util_1.calendarUtil.getReloadPeriod(calendar).start) &&
                    (0, moment_1.default)(s.period.start).isSameOrBefore(util_1.calendarUtil.getReloadPeriod(calendar).end)) {
                    const ee = employees[s.userId];
                    const pos = positions.find((p) => s.positionId === p.id);
                    // shift events
                    return {
                        // elemIdentifier: calendarUtil.getEvtIdentifier(s.id, moment(s.period.start).format('YYYY-MM-DD'), true),
                        userId: s.userId,
                        str: (ee
                            ? ee.name
                                .normalize('NFD')
                                .replace(/[\u0300-\u036f]/g, '')
                                .toLowerCase()
                            : '') +
                            '_' +
                            (pos
                                ? pos.name
                                    .normalize('NFD')
                                    .replace(/[\u0300-\u036f]/g, '')
                                    .toLowerCase()
                                : '') +
                            '_' +
                            (0, moment_1.default)(s.period.start).format('H:mm') +
                            '-' +
                            (0, moment_1.default)(s.period.end).format('H:mm'),
                    };
                }
            });
            Object.keys(employees)
                .map((idx) => employees[idx])
                .map((ee) => {
                relevantItems.push({
                    userId: ee.id,
                    str: ee.name
                        .normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, '')
                        .toLowerCase(),
                });
            });
            relevantItems = relevantItems.filter((el) => typeof el !== typeof undefined);
            // match them to search query
            const matchedRows = [];
            const queryWords = query.split(' ');
            relevantItems
                .map((ev) => {
                const matches = [];
                queryWords.map((qw) => {
                    const m = ev.str.match(qw);
                    if (m && m.length)
                        matches.push(qw);
                });
                // all query words matched
                if (matches.length === queryWords.length) {
                    if (!matchedRows.includes(ev.userId))
                        matchedRows.push(ev.userId);
                }
            })
                .filter((el) => typeof el !== typeof undefined);
            // and send the search results to store
            setCalendarSearch({
                query,
                results: matchedRows.map((m) => {
                    return { type: 'row', id: m };
                }),
            });
            // scroll to the topmost matched element
            setTimeout(() => {
                const whichSection = [
                    'is-section-bottom',
                    'is-section-unassigned',
                    'is-section-offers',
                ];
                whichSection.forEach((which) => {
                    let topmostPos = 9999999;
                    document
                        .querySelectorAll('.ds-c-section.' + which + ' .ds-c-row.is-highlighted')
                        .forEach((el) => {
                        const offset = el.offsetTop -
                            document.querySelector('.ds-c-section.' + which).offsetTop;
                        if (offset < topmostPos)
                            topmostPos = offset;
                    });
                    const el = document.querySelector('.ds-c-section.' + which);
                    if (el)
                        el.scrollTo({ top: topmostPos - 4, behavior: 'smooth' });
                });
            }, 700);
        }
    }
    // handle keyboard shortcuts on manager's calendar
    _handleKeypress(evt) {
        const { setCalendar, calendar, calendarMultiSelect, setCalendarMultiSelect, isPluginEnabled, shifts, setModal, } = this.props;
        const ctrlDown = evt.ctrlKey || evt.metaKey;
        // don't register anything here if some modal is open
        if (this.props.currentLayer?.modals?.length) {
            return;
        }
        // Text-editing keys belong to whatever the manager is typing into — the assistant
        // composer, the search box, any input. Ctrl+A/C/V and Delete are calendar shortcuts only
        // while nothing editable is focused; Ctrl+F, Ctrl+P and Esc stay global (Ctrl+F with the
        // search input focused is what selects its text, Esc is what closes it). A text selection
        // anywhere on the page claims Ctrl+C the same way: copying the selected text beats
        // copying shifts.
        const active = document.activeElement;
        const isTyping = active &&
            (['INPUT', 'TEXTAREA', 'SELECT'].includes(active.tagName) ||
                active.isContentEditable);
        const isEditingKey = evt.keyCode === 46 || (ctrlDown && [65, 67, 86].includes(evt.keyCode));
        const hasTextSelection = !!window.getSelection()?.toString().length;
        if ((isTyping && isEditingKey) ||
            (hasTextSelection && ctrlDown && evt.keyCode === 67)) {
            return;
        }
        // Ctrl+F
        if (ctrlDown && evt.keyCode === 70) {
            if (!this.state.searchActive) {
                // open search
                this.setState((s) => Object.assign({}, s, { searchActive: true }));
                evt.preventDefault();
            }
            else {
                // or select the text in search input
                const el = document.querySelector('.ds-st-search .ds-input-el.tt-input');
                if (el)
                    el.select();
                evt.preventDefault();
            }
        }
        // Ctrl+P
        if (ctrlDown && evt.keyCode === 80) {
            if (isPluginEnabled('attendance')) {
                this.props.setModal('export-excel');
            }
            else {
                setModal('plugin-detail', { plugin: { plugin: 'attendance' } });
            }
            evt.preventDefault();
        }
        // Esc
        if (evt.keyCode === 27) {
            // disable open column's context menu tooltip
            if (calendar.contextMenuForColumn)
                setCalendar({ contextMenuForColumn: undefined });
            // deactivate the search if it's active
            if (this.state.searchActive)
                this.setState((s) => Object.assign({}, s, { searchActive: false }));
            // cancel multiselection
            if (calendarMultiSelect.isActive) {
                util_1.multiSelectUtil.multiSelectClear();
            }
        }
        // Delete
        if (evt.keyCode === 46) {
            // delete
            if (util_1.multiSelectUtil
                .getMultiSelectAllowedActionTypes(isPluginEnabled)
                .some((a) => a.type === 'delete'))
                util_1.multiSelectUtil.multiSelectExecuteAction('delete');
        }
        // Ctrl+C
        if ((evt.ctrlKey || evt.metaKey) && evt.keyCode === 67) {
            if (util_1.multiSelectUtil
                .getMultiSelectAllowedActionTypes(isPluginEnabled)
                .some((a) => a.type === 'copy')) {
                util_1.notification.success({ code: 'eventCopied' });
                setCalendarMultiSelect({
                    action: 'copy',
                    isSelectingTargets: true,
                    targets: [],
                });
            }
            else if (util_1.multiSelectUtil
                .getMultiSelectAllowedActionTypes(isPluginEnabled)
                .some((a) => a.type === 'applyShiftTemplate')) {
                util_1.notification.success({ code: 'eventCopied' });
                setCalendarMultiSelect({
                    action: 'applyShiftTemplate',
                    isSelectingTargets: true,
                    targets: [],
                });
            }
        }
        // Ctrl+V
        if ((evt.ctrlKey || evt.metaKey) &&
            evt.keyCode === 86 &&
            !this.state.msExecuteInProgress) {
            if (calendarMultiSelect.sourceEvents.length === 1 &&
                calendarMultiSelect.targets.length > 0) {
                // copying an event
                if (calendarMultiSelect.action === 'copy') {
                    if (calendarMultiSelect.sourceEvents[0].positionId) {
                        util_1.multiSelectUtil
                            .multiSelectCopyShiftToTargets(calendarMultiSelect.sourceEvents[0])
                            .then(() => {
                            util_1.multiSelectUtil.multiSelectClear();
                        });
                    }
                    else {
                        util_1.multiSelectUtil
                            .multiSelectCopyUnavailabilityToTargets(calendarMultiSelect.sourceEvents[0])
                            .then(() => {
                            util_1.multiSelectUtil.multiSelectClear();
                        });
                    }
                }
                // applying a shift template
                if (calendarMultiSelect.action === 'applyShiftTemplate') {
                    util_1.multiSelectUtil.createShiftsFromShiftTemplateMulti(calendarMultiSelect.sourceEvents[0], calendarMultiSelect.targets);
                }
            }
        }
        // Ctrl+A
        if ((evt.ctrlKey || evt.metaKey) && evt.keyCode === 65) {
            const allEvents = shifts.filter((s) => (0, moment_1.default)(s.period.start).isSameOrAfter((0, moment_1.default)(calendar.date).startOf(calendar.view)) &&
                (0, moment_1.default)(s.period.end).isBefore((0, moment_1.default)(calendar.date).endOf(calendar.view))) || [];
            setCalendarMultiSelect({
                action: null,
                isSelectingTargets: false,
                targets: [],
                sourceEvents: allEvents,
            });
            evt.preventDefault();
        }
    }
    componentDidMount() {
        document.addEventListener('keydown', this.handleKeypress, false);
    }
    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeypress, false);
    }
    _setCalendarWarnings(whichWarnings) {
        const { calendarFilters, setCalendarFilters } = this.props;
        let newFilters = calendarFilters.slice();
        newFilters = newFilters.filter((fil) => !fil.hideWarnings);
        if (whichWarnings)
            newFilters.push({ hideWarnings: whichWarnings });
        setCalendarFilters(newFilters);
    }
    render() {
        const { me, className, offers, calendarFilters, calendar, setModal, workspace, workspaceId, isPluginEnabled, warningCounts, countWarningsByType, 
        // deleteLiveShift,
        shifts, employees, isLoadingRelevantData, togglePlugin, } = this.props;
        const cN = ['ds-c-controls'];
        if (className)
            cN.push(className);
        if (this.state.filtersActive)
            cN.push('display-filters');
        const monthOpts = [];
        if (calendar.view === 'month') {
            for (let i = -6; i <= 6; i++) {
                const label = (0, moment_1.default)(calendar.date).add(i, 'months').format('MMMM YYYY');
                monthOpts.push({
                    label: label.charAt(0).toUpperCase() + label.slice(1),
                    value: (0, moment_1.default)(calendar.date).add(i, 'months').format('YYYY-MM-DD'),
                });
            }
        }
        const hiddenWarnings = calendarFilters.find((fil) => fil.hideWarnings);
        const laborlawPlugin = workspace?.plugins?.find((p) => p.plugin === 'laborlaw');
        const laborlawPluginEnabled = Boolean(laborlawPlugin && laborlawPlugin.enabled);
        const offersPlugin = Object.assign({}, workspace?.plugins?.find((p) => p.plugin === 'offers'), plugin_config_1.default.SUPPORTED_PLUGINS.find((p) => p.id === 'offers'));
        const shiftWarningTypes = laborlawPlugin && laborlawPlugin.options
            ? laborlawPlugin.options.warnings.filter((w) => ['shift', 'timeOff'].includes(w.type))
            : [];
        let warningCountsFiltered = 0;
        if (!hiddenWarnings) {
            warningCountsFiltered = warningCounts;
        }
        else {
            if (hiddenWarnings.hideWarnings !== 'all' &&
                hiddenWarnings.hideWarnings !== true) {
                Object.keys(countWarningsByType)
                    .filter((k) => k !== 'all' && k !== true)
                    .forEach((k) => {
                    if (!hiddenWarnings ||
                        !hiddenWarnings.hideWarnings ||
                        (!hiddenWarnings.hideWarnings.includes(k) &&
                            !hiddenWarnings.hideWarnings.find((hw) => k.includes(hw + '_'))) /* sometimes, we need type like 'shiftDuration' to also match warnings like 'shiftDuration_long'. they appear, but are not in plugins.options */) {
                        warningCountsFiltered += countWarningsByType[k];
                    }
                });
            }
        }
        const calPeriod = calendar && util_1.calendarUtil.getReloadPeriod(calendar);
        const filteredShiftsInPeriod = (shifts?.length && calPeriod
            ? util_1.calendarUtil.getFilteredEvents(shifts, calendarFilters)
            : []).filter((s) => (0, moment_1.default)(s.period.start).isSameOrAfter(calPeriod.start) &&
            (0, moment_1.default)(s.period.start).isSameOrBefore(calPeriod.end));
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(_ui_1.Flex, { flex: 1 },
                react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: 'assistant-button-wrapper' },
                        react_1.default.createElement(_ui_1.Button, { style: _ui_1.Button.STYLES.CONTAINED, bold: true, label: (0, i18n_1.t)('ASSISTANT.title'), onClick: () => {
                                this.props.setManagerAssistantExpanded(true);
                            }, ico: _ui_1.Icon.ICONS.assistant, disabled: util_1.miscUtil.isMyCalendarLocked(calendar?.period?.end, workspace), onClickActiveWhenDisabled: true })),
                    react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_4, type: _ui_1.Spacing.TYPES.HORIZONTAL })),
                react_1.default.createElement(_ui_1.Button, { style: _ui_1.Button.STYLES.OUTLINED, ico: _ui_1.Icon.ICONS.plus, bold: true, label: (0, i18n_1.t)('PLANNING_BTN_LABEL'), onClick: () => {
                        setModal('planning');
                    }, disabled: util_1.miscUtil.isMyCalendarLocked(calendar?.period?.end, workspace) }),
                react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_4, type: _ui_1.Spacing.TYPES.HORIZONTAL }),
                react_1.default.createElement(_ui_1.Dropdown, { label: null, singleSelect: true, sortedOptions: false, size: _ui_1.Dropdown.SIZES.MEDIUM, type: _ui_1.Dropdown.TYPES.VARIABLE, style: _ui_1.Dropdown.STYLES.OUTLINED, disabled: util_1.miscUtil.isMyCalendarLocked(calendar?.period?.end, workspace), options: [
                        { value: 'addShift', label: (0, i18n_1.t)('ADD_SHIFT') },
                        { value: 'addAbsence', label: (0, i18n_1.t)('ADD_ABSENCE') },
                        { value: 'addUnavailability', label: (0, i18n_1.t)('ADD_UNAVAILABILITY') },
                        { value: 'addAvailability', label: (0, i18n_1.t)('ADD_UNAVAILABILITY_AVAIL') },
                        { value: '', label: '' },
                        { value: 'addPosition', label: (0, i18n_1.t)('ADD_POSITION') },
                        { value: 'addTemplate', label: (0, i18n_1.t)('ADD_TEMPLATE_CONTROLS') },
                        { value: 'addLocality', label: (0, i18n_1.t)('ADD_LOCALITY_CONTROLS') },
                        { value: 'addCycle', label: (0, i18n_1.t)('ADD_CYCLE_CONTROLS') },
                    ].filter(Boolean), value: [], placeholder: (0, i18n_1.t)('ADD'), testid: 'add-button', onChange: (v) => {
                        switch (v.value) {
                            case 'addShift':
                                this.props.openModal(shift_1.ShiftModal, {
                                    initialData: {
                                        type: 'live',
                                        data: {
                                            period: {
                                                start: (0, moment_1.default)(calendar.date).set({
                                                    hour: 8,
                                                    minute: 0,
                                                    second: 0,
                                                }),
                                                end: (0, moment_1.default)(calendar.date).set({
                                                    hour: 16,
                                                    minute: 30,
                                                    second: 0,
                                                }),
                                            },
                                        },
                                    },
                                });
                                break;
                            case 'addUnavailability':
                                this.props.openModal(unavailability_modal_1.UnavailabilityModal, {
                                    initialData: {
                                        categoryId: use_workspace_unavailability_categories_1.UNAVAILABILITY_VALUE,
                                        period: {
                                            start: (0, moment_1.default)(calendar.date).format('YYYY-MM-DD'),
                                        },
                                    },
                                });
                                break;
                            case 'addAvailability':
                                this.props.openModal(unavailability_modal_1.UnavailabilityModal, {
                                    initialData: {
                                        categoryId: use_workspace_unavailability_categories_1.AVAILABILITY_VALUE,
                                        period: {
                                            start: (0, moment_1.default)(calendar.date).format('YYYY-MM-DD'),
                                        },
                                    },
                                });
                                break;
                            case 'addAbsence':
                                this.props.openModal(unavailability_modal_1.UnavailabilityModal, {
                                    initialData: {
                                        period: {
                                            start: (0, moment_1.default)(calendar.date).format('YYYY-MM-DD'),
                                        },
                                    },
                                });
                                break;
                            case 'addPosition':
                                setModal('position-editor');
                                break;
                            case 'addTemplate':
                                util_1.routeUtil.navigate('/workspace/day-templates/create');
                                break;
                            case 'addLocality':
                                setModal('extra-locality', { employees });
                                break;
                            case 'addCycle':
                                util_1.routeUtil.navigate('/workspace/cycles/create');
                                break;
                            default:
                                return false;
                        }
                    } }),
                react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_4, type: _ui_1.Spacing.TYPES.HORIZONTAL }),
                react_1.default.createElement(_ui_1.Button, { onClick: () => {
                        if (isPluginEnabled('offers')) {
                            setModal('offers', {
                                selectedShiftIds: [],
                                action: offers.find((off) => off.status === 'managerRequestApproval')
                                    ? 'approve'
                                    : offers.find((off) => off.status === 'managerResultApproval')
                                        ? 'resolve'
                                        : offers.find((off) => off.status === 'employeeReplies')
                                            ? 'show'
                                            : 'create',
                            });
                        }
                        else {
                            setModal('plugin-detail', { plugin: offersPlugin });
                        }
                    }, ico: _ui_1.Icon.ICONS.person, bold: true, disabled: util_1.miscUtil.isMyCalendarLocked(calendar?.period?.end, workspace) },
                    react_1.default.createElement("div", { className: 'ds-st-actions-label' }, (0, i18n_1.t)('OFFERS')),
                    offers.filter((off) => ['managerRequestApproval', 'managerResultApproval'].includes(off.status)).length > 0 && (react_1.default.createElement("div", { className: 'ds-c-set-offers-count' }, offers.filter((off) => ['managerRequestApproval', 'managerResultApproval'].includes(off.status)).length))),
                react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_4, type: _ui_1.Spacing.TYPES.HORIZONTAL }),
                react_1.default.createElement(_ui_1.Button, { ico: _ui_1.Icon.ICONS.back, bold: true, onClick: () => {
                        setModal('publish-changes', { undo: true });
                    }, label: (0, i18n_1.t)('REVERT_CHANGES'), disabled: util_1.miscUtil.isMyCalendarLocked(calendar?.period?.end, workspace) }),
                react_1.default.createElement("div", { className: 'ds-c-loading-indicator', style: { opacity: isLoadingRelevantData?.length ? 1 : 0 } },
                    react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_4, type: _ui_1.Spacing.TYPES.HORIZONTAL }),
                    react_1.default.createElement(_ui_1.Alert, { text: (0, i18n_1.t)('LOADING').charAt(0).toUpperCase() +
                            (0, i18n_1.t)('LOADING').slice(1) +
                            ': ' +
                            isLoadingRelevantData
                                .map((l) => (0, i18n_1.t)(l).toString().toLowerCase().trim())
                                .join(', '), type: _ui_1.Alert.TYPES.WARNING, customIco: _ui_1.Icon.ICONS.loader, size: _ui_1.Alert.SIZES.FULL_WIDTH, variant: _ui_1.Alert.VARIANTS.NORMAL }),
                    react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_4, type: _ui_1.Spacing.TYPES.HORIZONTAL }))),
            react_1.default.createElement(_ui_1.Flex, { justify: _ui_1.Flex.POSITION.END, stretch: true },
                react_1.default.createElement(_ui_1.Flex, { justify: _ui_1.Flex.POSITION.END, stretch: true }, !this.state.searchActive ? (react_1.default.createElement(_ui_1.Button, { ico: _ui_1.Icon.ICONS.search, onClick: () => {
                        this.setState((s) => Object.assign({}, s, { searchActive: true }));
                    }, bold: true },
                    react_1.default.createElement("div", { className: 'ds-st-actions-label' }, (0, i18n_1.t)('SEARCH')))) : (react_1.default.createElement(components_1.SearchInput, { onChange: (val) => {
                        this.setState((s) => Object.assign({}, s, { searchQuery: val }));
                        clearTimeout(this.searchTimer);
                        this.searchTimer = setTimeout(this.applySearch, 800, val);
                    }, onKeyDown: ({ keyCode }) => {
                        if (keyCode === 27) {
                            // escape
                            this.setState((s) => Object.assign({}, s, { searchActive: false, searchQuery: '' }));
                            this.applySearch('');
                        }
                    }, onCancel: () => {
                        this.setState((s) => Object.assign({}, s, { searchActive: false, searchQuery: '' }));
                        this.applySearch('');
                    }, value: this.state.searchQuery }))),
                react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_4, type: _ui_1.Spacing.TYPES.HORIZONTAL }),
                react_1.default.createElement(_ui_1.Flex, { ref: this.props.controlsRef, justify: _ui_1.Flex.POSITION.END, shrink: true },
                    react_1.default.createElement(_ui_1.Button, { bold: true, onClick: () => this.props.setFiltersActive(true), ico: _ui_1.Icon.ICONS.filters },
                        (0, i18n_1.t)('FILTER'),
                        calendarFilters.filter((f) => !f.hideWarnings).length ? (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.HORIZONTAL, size: _ui_1.Spacing.SIZES.SIZE_6 }),
                            react_1.default.createElement(_ui_1.CircledNumber, { number: calendarFilters.filter((f) => !f.hideWarnings).length, color: _ui_1.CircledNumber.COLORS.WARNING }))) : null),
                    react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_4, type: _ui_1.Spacing.TYPES.HORIZONTAL }),
                    react_1.default.createElement(components_1.WarningsTooltip, { workspaceId: workspaceId, calendarDate: calendar?.date, laborlawPluginEnabled: laborlawPluginEnabled, laborlawPlugin: laborlawPlugin, warningCountsFiltered: warningCountsFiltered, hiddenWarnings: hiddenWarnings, onChangeEnabledAll: (val) => {
                            if (hiddenWarnings &&
                                (hiddenWarnings.hideWarnings === 'all' ||
                                    hiddenWarnings.hideWarnings === true)) {
                                this.setCalendarWarnings(undefined);
                            }
                            else {
                                this.setCalendarWarnings('all');
                            }
                        }, onHandlePluginChange: () => {
                            togglePlugin(laborlawPlugin, calendar);
                        }, shiftWarningTypes: shiftWarningTypes, countWarningsByType: countWarningsByType, setCalendarWarnings: this.setCalendarWarnings }),
                    react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_4, type: _ui_1.Spacing.TYPES.HORIZONTAL }),
                    react_1.default.createElement(_ui_1.Button, { bold: true, disabled: !isPluginEnabled('attendance'), onClickActiveWhenDisabled: true, onClick: () => {
                            if (isPluginEnabled('attendance')) {
                                if (me.hasPassword) {
                                    setModal('export-excel');
                                }
                            }
                            else {
                                setModal('plugin-detail', { plugin: { plugin: 'attendance' } });
                            }
                        }, ico: _ui_1.Icon.ICONS.export, label: (0, i18n_1.t)('TABLE_EXPORT') }),
                    react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_4, type: _ui_1.Spacing.TYPES.HORIZONTAL }),
                    react_1.default.createElement(_ui_1.Button, { ico: 'settings-full', bold: true, onClick: () => {
                            this.props.openModal(calendar_settings_modal_1.CalendarSettingsModal);
                        } }, (0, i18n_1.t)('VIEW_BTN')),
                    react_1.default.createElement(_ui_1.Spacing, { size: _ui_1.Spacing.SIZES.SIZE_4, type: _ui_1.Spacing.TYPES.HORIZONTAL })))));
    }
}
exports.default = (0, connect_1.default)((0, use_modal_hoc_1.withUseModalHOC)(Controls));
